// src/app/pages/doctor/doctor-profile/doctor-profile.component.ts
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {MedicByIdUser} from "@core/models/MedicByIdUser";
import {PatientByIdMedic} from "@core/models/PatientByIdMedic";
import {BreadcrumbComponent} from "@shared/components/breadcrumb/breadcrumb.component";
import {FormatMobilePipe} from "@core/pipes/format-mobile.pipe";
import {MatIcon} from "@angular/material/icon";
import {
  PrescriptionByIdDoctorComponent
} from "../../../prescription/prescription-list/prescription-by-id-doctor/prescription-by-id-doctor.component";
import {UserRole} from "@core/models/Enums/UserRole";
import {AuthManagementService} from "@core/service/auth-management.service";
import {HttpErrorResponse} from "@angular/common/http";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {NgIf} from "@angular/common";
import {DoctorService} from "@core/http/table-data-services/Doctor.service";
import {UserService} from "@core/http/table-data-services/User.service";

@Component({
  selector: 'app-doctor-profile',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    FormatMobilePipe,
    MatIcon,
    PrescriptionByIdDoctorComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    NgIf,
  ],
  templateUrl: './doctor-profile.component.html',
  styleUrl: './doctor-profile.component.scss'
})
export class DoctorProfileComponent implements OnInit {
  param: string | null = null;
  param2: string | null = null;

  // Imagen mostrada en el panel
  userImagen: string | null = null;
  // Firma mostrada en su tarjeta
  firmaDataUrl: string | null = null;

  private readonly DOCTOR_FALLBACK = 'assets/images/doctor.png';

  rol = 'Medico';
  userRole: string | undefined;

  doctor: MedicByIdUser;
  patients: PatientByIdMedic[] = [];

  protected readonly UserRole = UserRole;

  constructor(
    private route: ActivatedRoute,
    public authService: AuthManagementService,
    private httpMsgHandler: HttpMesageHandlerService,
    private doctorService: DoctorService,
    private userService: UserService,
  ) {
    this.route.paramMap.subscribe(params => {
      const param = params.get('param');
      this.param = param ? atob(param) : null;

      const param2 = params.get('param2');
      this.param2 = param2 ? atob(param2) : null;
    });

    this.doctor = {} as MedicByIdUser;
    this.userRole = authService.userData().IdTipoUsuario;
  }

  private assetToDataUrl(asset: any): string | null {
    const b64 = String(asset?.base64 || '').trim();
    if (!b64) return null;
    const ct = String(asset?.contentType || 'image/jpeg');
    return `data:${ct};base64,${b64}`;
  }

  // --- Carga de datos ---------------------------------------------------------

  getDoctorDetails(param: string) {
    this.doctorService.getDoctorByIdDoctor(param).subscribe({
      next: (res: DefaultResponse<MedicByIdUser>) => {
        this.doctor = res.data;

        // fallback por si no hay nada
        this.userImagen = this.DOCTOR_FALLBACK;
        this.firmaDataUrl = null;

        const idUsuario =
          (this.doctor as any)?.idUsuario ||
          (this.doctor as any)?.IdUsuario ||
          (this.doctor as any)?.id_user;

        if (!idUsuario) return;

        forkJoin({
          img: this.userService.getUsuarioImagen(String(idUsuario))
            .pipe(catchError(() => of(null))),
          firma: this.userService.getUsuarioAsset(String(idUsuario), 2)
            .pipe(catchError(() => of(null))),
        }).subscribe(({ img, firma }) => {
          // img?.data y firma?.data traen el objeto desencriptado:
          // { contentType, bytesSize, widthPx, heightPx, base64, ... }

          const imgUrl = this.assetToDataUrl((img as any)?.data);
          this.userImagen = imgUrl ?? this.DOCTOR_FALLBACK;

          const firmaUrl = this.assetToDataUrl((firma as any)?.data);
          this.firmaDataUrl = firmaUrl ?? null;
        });
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
        this.userImagen = this.DOCTOR_FALLBACK;
        this.firmaDataUrl = null;
      }
    });
  }


  ngOnInit(): void {
    if (this.param) {
      this.getDoctorDetails(this.param);
    }
  }
}
